export enum InventoryType {
  LONG = 'Long Position',
  SHORT = 'Short Position',
  ISSUE = 'Issued Position',
}

export interface Inventory {
  id: string
  name: string
}

export type InventoryTypeKey = keyof typeof InventoryType

export const inventories: Inventory[] = Object.entries(InventoryType).map(
  ([propertyKey]) => ({ id: propertyKey, name: propertyKey }),
)
